import { AbilityBuilder, createMongoAbility } from '@casl/ability';

import { AnyPermission } from '../types';

// Enhance CASL to treat string subjects as wildcards
export function createAbilityFromPermissions(permissions: AnyPermission[]) {
  const ability = new AbilityBuilder(createMongoAbility);

  for (const permission of permissions) {
    ability[permission.type ?? 'can'](permission.action, permission.subject, permission.conditions);
  }

  return ability.build();
}
